import { IconWithSpinner } from '@/core/IconWithSpinner.atom';
import clsx from 'clsx';

interface LoadingFallbackProps {
  size?: 'lg' | 'sm';
}

/**
 * Loading spinner to use as the fallback with React.Suspense. Fills the entire element.
 */
export const LoadingFallback: React.FunctionComponent<LoadingFallbackProps> = ({ size = 'lg' }) => {
  return (
    <div data-testid="loadingFallback" className="flexColumnContainer flexCenter flexFill height-maximum">
      <IconWithSpinner spinning={true} extraClassNames={clsx({ 'fa-5x': size === 'lg' })} />
    </div>
  );
};
